/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import Select from 'react-select';
import { Form, ButtonGroup, Spinner } from 'react-bootstrap';

import { STATE_STATUS, FAKE_SEPARATOR, Permissions } from '@awp/constants';

import {
  currentGraphView,
  currentGraphViewId,
  selectAllGraphViewsSorted,
  selectStatus,
} from '@stores/graphViewPageSlice';

import GraphViewActions from '@graphs/SingleStation/GraphView/Actions';
import Authorize from '@components/Authorize';

const formatOptionLabel = (option) => {
  if (option.label == FAKE_SEPARATOR) {
    return <div className="dropdown__selector-hack">&nbsp;</div>;
  }

  return (
    <div style={{ display: 'flex' }}>
      <div>
        {!option.system && <i className="bi bi-person-fill" style={{ color: 'blue' }}></i>} {option.label}
      </div>
      {option.unsaved ? (
        <div style={{ marginLeft: '10px', fontSize: '1em' }}>(Unsaved)</div>
      ) : option.modified ? (
        <div style={{ marginLeft: '10px', fontSize: '1em' }}>(Edited)</div>
      ) : (
        ''
      )}
    </div>
  );
};

const GraphViewsDropdown = ({ GraphViewChanged }) => {
  const status = useSelector(selectStatus);

  const sortedGraphViews = useSelector(selectAllGraphViewsSorted);
  const graphView = useSelector(currentGraphView);

  const dispatch = useDispatch();
  //const [selectedValue, setSelectedValue] = useState();

  //const [selectedValue, setSelectedValue] = useState();

  /*
	const status = useSelector(selectStatus);

	const sortedGraphViews = useSelector(selectAllGraphViewsSorted);
	const selectedGraphView = useSelector(currentGraphViewId);
	const dispatch = useDispatch();
	const [selectedValue, setSelectedValue] = useState(null);

	useEffect(() => {
		if (graphView) {
			setSelectedValue({
				value: graphView.Id,
				label: graphView.Name,
				unsaved: graphView.IsUnsaved || false,
				modified: graphView.IsModified || false,
				system: graphView.IsSystem || false,
			});
		}
	}, []);
*/

  const LoadingIndicator = () => {
    return (
      <div className="legend__loading">
        <Spinner animation="border" size="sm" variant="primary" />
      </div>
    );
  };

  function handleChange(selOption) {
    dispatch(GraphViewChanged(selOption.value));
  }

  const selectStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderColor: '#adb5bd',
      color: '#494949',
    }),
    container: (styles) => ({ ...styles, width: '100%' }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles, color: '#494949' }),
    dropdownIndicator: (styles) => ({ ...styles, color: '#797979', '&:hover': { color: '#494949' } }),
  };

  return (
    <div>
      <Form.Label>
        <b>Graph View</b>
      </Form.Label>
      <ButtonGroup style={{ width: '100%' }}>
        <Select
          options={sortedGraphViews.map((gv) => {
            return {
              value: gv.Id,
              label: gv.Name,
              unsaved: gv.IsUnsaved || false,
              modified: gv.IsModified || false,
              system: gv.IsSystem || false,
            };
          })}
          styles={selectStyles}
          value={
            graphView
              ? {
                  value: graphView?.Id,
                  label: graphView?.Name,
                  unsaved: graphView?.IsUnsaved || false,
                  modified: graphView?.IsModified || false,
                  system: graphView?.IsSystem || false,
                }
              : null
          }
          placeholder={'Select graph view'}
          onChange={handleChange}
          isLoading={status.graphViews !== STATE_STATUS.SUCCESS}
          components={{ LoadingIndicator }}
          formatOptionLabel={formatOptionLabel}
          isOptionDisabled={(option) => option.label === FAKE_SEPARATOR}
        />
        <Authorize requires={[Permissions.WriteCustomGraph]}>
          {status.graphViews === STATE_STATUS.SUCCESS ? <GraphViewActions /> : <></>}
        </Authorize>
      </ButtonGroup>
    </div>
  );
};

GraphViewsDropdown.propTypes = {
  GraphViewChanged: PropTypes.func,
};

export default GraphViewsDropdown;
